export type PaginationType = {
  total: number;
  page: number;
  resultsPerPage: number;
  numPages: number;
};

export const initialPagination: PaginationType = {
  total: 0,
  page: 0,
  resultsPerPage: 10,
  numPages: 0,
};
